.agentName {
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.agentBadge {
  flex-shrink: 0;
  white-space: nowrap;
}
